import React, { useEffect, useState } from 'react';
import AppRoutes from './components/AppRoutes';

function App() {

  return <AppRoutes />;
}

export default App;
